import React, { memo } from 'react';

import { CustomerSummary } from './CustomerSummary';
import { IdRow } from './IdRow';
import { useProfileWidgetStore } from './StoreProvider';
import { UserTypeRow } from './UserTypeRow';

export const EmployeeSummary = memo(() => {
  const { profile } = useProfileWidgetStore();

  if (profile?.servicePointId) {
    return <CustomerSummary />;
  }

  return (
    <>
      <IdRow />
      <UserTypeRow />
    </>
  );
});
